const newsDetail = {

}


export default {
  title: '新闻',
  tabs: [
    '企业新闻',
    '企业声明',
    '产品资讯',
    '产品业绩',
    '全部',
  ],
  newsDetail,
}


// WEBPACK FOOTER //
// ./src/config/lang/zh-CN/newsPage.js